import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/app.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './stores';
import { Provider } from 'mobx-react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <div>
    <Provider store={store}>
      <App />
    </Provider>
  </div>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
